export const selectTypes = {
    addSelectOptions: "[Selects] Add Select Options",
};
